define('atlas/AtlasPreloader', [], function() {
    'use strict';

    var AtlasPreloader = function() {
        this._images = [];
        this._loadCount = 0;
    };

    AtlasPreloader.prototype.addImage = function(image) {
        this._images.push(image);
    };

    AtlasPreloader.prototype.load = function() {
        this._loadCount = this._images.length;

        for (var i = 0; i < this._images.length; ++i) {
            var image = new Image();
            image.src = this._images[i];
        }
    };

    AtlasPreloader.prototype.syncLoad = function(callback) {
        this._loadCount = 0;
        this._callback = callback;

        var loading = [];

      /* jshint loopfunc: true */
        for (var i = 0; i < this._images.length; ++i) {
            var image = new Image();
            image.loader = this;
            image.onload = function() {
                this.loader._loadCount++;
                if ((this.loader._loadCount === this.loader._images.length) && (this.loader._callback)) {
                    this.loader._callback();
                }

            };
            image.src = this._images[i];
        }
    };

    return AtlasPreloader;
});
